import React from "react";

function LogoTextComponent() {
  return (
    <h6 className="logo-text">
      <span className="text-gradient">Bazaar</span>
    </h6>
  );
}

export default LogoTextComponent;